<template>
  <header :class="['app-header', {'app-header-slide': slide}]">
    <div class="app-header-box">
      <router-link class="header-link header-logo-icon" to="/">
        <svg-icon
          icon-class="headerLogo"
          class="logo-icon logo-icon-logo"
        ></svg-icon>
      </router-link>
      <div class="header-link-nav">
        <router-link class="header-link" to="/school-class">學院課程</router-link>
        <router-link class="header-link" to="/reborn-workshop">工作坊/講座</router-link>
        <!-- <router-link class="header-link" to="/reborn-lecture">講座</router-link> -->
        <!-- <router-link class="header-link" to="/">學生作品</router-link> -->
        <router-link class="header-link" to="/about-us">關於 Reborn</router-link>
      </div>
      <div v-if="isLogin" class="header-link-nav">
        <router-link class="header-login-box" to="/account-coupon">
          <img class="header-login-icon" src="@/assets/images/BomBom.png" alt="ui">
          <span>{{ loginName }}</span>
        </router-link>
      </div>
      <div v-else class="header-link-nav">
        <div @click="openLoginPopup" class="header-link">登入</div>
        <div @click="openRegisterPopup" class="btn-secondary header-link-register">註冊</div>
      </div>
      <!-- 多種註冊 popup -->
      <div v-if="isShowRegisterPopup" @click="closeRegisterPopup" class="header-popup">
        <div @click.stop class="popup-box">
          <div class="popup-close">
            <div @click="closeRegisterPopup">
              <svg-icon
                icon-class="close"
                class="close"
              ></svg-icon>
            </div>
          </div>
          <div class="popup-title">註冊</div>
          <form class="popup-google" name='facebookLogin' method='get' action='https://api.reborn.in/oauth2/authorization/google'>
            <svg-icon
              icon-class="googleIcon"
              class="google"
            ></svg-icon>
            <input class="popup-google-input" type='submit' value='使用 Google 註冊'>
          </form>
          <form class="popup-google" name='facebookLogin' method='get' action='https://api.reborn.in/oauth2/authorization/facebook'>
            <svg-icon
              icon-class="fbIcon"
              class="google"
            ></svg-icon>
            <input class="popup-google-input" type='submit' value='使用 Facebook 註冊'>
          </form>
          <!-- <div class="popup-google">
            <svg-icon
              icon-class="googleIcon"
              class="google"
            ></svg-icon>
            使用 Google 註冊
          </div>
          <div class="popup-google">
            <svg-icon
              icon-class="fbIcon"
              class="google"
            ></svg-icon>
            使用 Facebook 註冊
          </div> -->
          <!-- <div @click="openMailRegisterPopup1" class="popup-google">
            <svg-icon
              icon-class="mailIcon"
              class="google"
            ></svg-icon>
            使用電子郵件註冊
          </div>
          <div class="popup-hint">
            已經有帳號了嗎？<span @click="openLoginPopup" class="popup-dash">登入</span>
          </div> -->
        </div>
      </div>
      <!-- 郵件註冊 popup 1 -->
      <div v-if="isShowMailRegisterPopup1" @click="closeMailRegisterPopup1" class="header-popup">
        <div @click.stop class="popup-box">
          <div class="popup-close">
            <div @click="closeMailRegisterPopup1">
              <svg-icon
                icon-class="close"
                class="close"
              ></svg-icon>
            </div>
          </div>
          <div class="popup-title">註冊</div>
          <input style="margin-top: 0px;" class="popup-input" type="text" placeholder="填入真實姓名">
          <input class="popup-input" type="text" placeholder="Email">
          <input class="popup-input" type="text" placeholder="密碼">
          <div class="popup-btn">註冊</div>
          <div class="popup-hint">
            已經有帳號了嗎？<span @click="openLoginPopup" class="popup-dash">登入</span>
          </div>
        </div>
      </div>
      <!-- 登入 popup -->
      <div v-if="isShowLoginPopup" @click="closeLoginPopup" class="header-popup">
        <div @click.stop class="popup-box">
          <div class="popup-close">
            <div @click="closeLoginPopup">
              <svg-icon
                icon-class="close"
                class="close"
              ></svg-icon>
            </div>
          </div>
          <div class="popup-title">登入</div>
          <!-- <a href="https://api.reborn.in/login/oauth2/authorization/facebook" class="popup-google">
            <svg-icon
              icon-class="googleIcon"
              class="google"
            ></svg-icon>
            使用 Google 登入
          </a> -->
          <!-- <div @click="googleLoginBtn" class="popup-google">
            <svg-icon
              icon-class="googleIcon"
              class="google"
            ></svg-icon>
            使用 Google 登入
          </div> -->
          <form class="popup-google" name='facebookLogin' method='get' action='https://api.reborn.in/oauth2/authorization/google'>
            <svg-icon
              icon-class="googleIcon"
              class="google"
            ></svg-icon>
            <input class="popup-google-input" type='submit' value='使用 Google 登入'>
          </form>
          <form class="popup-google" name='facebookLogin' method='get' action='https://api.reborn.in/oauth2/authorization/facebook'>
            <svg-icon
              icon-class="fbIcon"
              class="google"
            ></svg-icon>
            <input class="popup-google-input" type='submit' value='使用 Facebook 登入'>
          </form>
          <!-- <div @click="facebookLoginBtn" class="popup-google">
            <svg-icon
              icon-class="fbIcon"
              class="google"
            ></svg-icon>
            使用 Facebook 登入
          </div> -->
          <!-- <a href="https://api.reborn.in/login/oauth2/authorization/google" class="popup-google">
            <svg-icon
              icon-class="fbIcon"
              class="google"
            ></svg-icon>
            使用 Facebook 登入
          </a> -->
          <!-- <div @click="openMailLoginPopup" class="popup-google">
            <svg-icon
              icon-class="mailIcon"
              class="google"
            ></svg-icon>
            使用電子郵件登入
          </div>
          <div class="popup-login-hint">
            還沒有帳號嗎？<span @click="openRegisterPopup" class="popup-dash">註冊</span>
          </div> -->
        </div>
      </div>
      <!-- 郵件登入 popup -->
      <div v-if="isShowMailLoginPopup" @click="closeMailLoginPopup" class="header-popup">
        <div @click.stop class="popup-box">
          <div class="popup-close">
            <div @click="closeMailLoginPopup">
              <svg-icon
                icon-class="close"
                class="close"
              ></svg-icon>
            </div>
          </div>
          <div class="popup-title">登入</div>
          <input class="popup-input" type="text" placeholder="Email">
          <input class="popup-input" type="text" placeholder="密碼">
          <div class="popup-btn">登入</div>
          <div @click="openForgetPassword" class="popup-login-hint">
            <div>忘記密碼？</div>
          </div>
        </div>
      </div>
      <!-- 忘記密碼 popup -->
      <div v-if="isShowForgetPassword" @click="closeForgetPassword" class="header-popup">
        <div @click.stop class="popup-box">
          <div class="popup-close">
            <div @click="closeForgetPassword">
              <svg-icon
                icon-class="close"
                class="close"
              ></svg-icon>
            </div>
          </div>
          <div class="popup-title">忘記密碼</div>
          <input class="popup-input" type="text" placeholder="信箱">
          <div class="popup-btn">重設密碼</div>
        </div>
      </div>
      <!---->
      <!-- 手機版漢堡 start -->
      <div v-if="showBurger" @click="switchMenu">
        <svg-icon
          icon-class="burger"
          class="burger-icon-burger"
        ></svg-icon>
      </div>
      <div v-if="menu"
        class="header-menu"
      >
        <div class="header-menu-top">
          <router-link class="header-link" to="/">
            <div @click="closeMenu">
              <svg-icon
                icon-class="headerLogo"
                class="logo-icon-reborn"
              ></svg-icon>
            </div>
          </router-link>
          <div @click="closeMenu">
            <svg-icon
              icon-class="close"
              class="logo-icon-close"
            ></svg-icon>
          </div>
        </div>
        <router-link class="header-menu-item" to="/school-class"><div @click="closeMenu">學院課程</div></router-link>
        <router-link class="header-menu-item" to="/reborn-workshop"><div @click="closeMenu">工作坊/講座</div></router-link>
        <!-- <router-link class="header-menu-item" to="/reborn-lecture"><div @click="closeMenu">講座</div></router-link> -->
        <!-- <router-link class="header-menu-item" to="/"><div @click="closeMenu">學生作品</div></router-link> -->
        <router-link class="header-menu-item" to="/about-us"><div @click="closeMenu">關於 reborn</div></router-link>
        <div class="header-menu-line"></div>
        <router-link v-if="isLogin" class="header-menu-item" to="/account-coupon"><div @click="closeMenu">我的帳戶</div></router-link>
        <!-- <div v-if="isLogin" @click="closeMenu" class="header-menu-item">登出</div> -->
        <!-- <router-link v-if="isLogin" class="header-menu-item" to="/account-coupon">
          <img class="header-login-icon" src="@/assets/images/BomBom.png" alt="ui">
          <span>{{ loginName }}</span>
        </router-link> -->
        <div v-if="!isLogin" @click="openLoginPopup" class="header-menu-item">登入</div>
        <div v-if="!isLogin" @click="openRegisterPopup" class="header-menu-item">註冊</div>
      </div>
      <!-- 手機版漢堡 end -->
    </div>
  </header>
</template>
<script>
// import axios from 'axios'
import ConfirmButton from '@/components/button/ConfirmButton'
// import { googleLogin } from '@/API/User'

export default {
  name: 'AppHeader',
  components: {
    ConfirmButton
  },
  data () {
    return {
      slide: false,
      showBurger: false,
      menu: false,
      isShowRegisterPopup: false,
      isShowMailRegisterPopup1: false,
      isShowMailRegisterPopup2: false,
      isShowRegisterMail: false,
      isShowLoginPopup: false,
      isShowMailLoginPopup: false,
      isShowForgetPassword: false,
      isShowCheckPasswordMail: false,
      isLogin: false,
      loginName: ''
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    document.addEventListener('click', this.autoHide, false)
    this.winWidth()
    // 顯示註冊/登入
    let url = location.search
    if (url.indexOf('?') !== -1) {
      let ary1 = url.split('?')
      let ary2 = ary1[1].split('&')
      // let ary3 = ary2[1].split('=')
      let ary4 = ary2[2].split('=')
      // let firstName = decodeURI(ary3[1])
      let lastName = decodeURI(ary4[1])
      this.loginName = lastName
      console.log(this.loginName)
      this.isLogin = true
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('click', this.autoHide, false)
  },
  methods: {
    handleScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // let offsetTop = document.querySelector('.home-white-line').offsetTop
      if (scrollTop > 40) {
        this.slide = true
      } else {
        this.slide = false
      }
    },
    autoHide (evt) {
      if (!this.menu) return false
      if (!this.$el.contains(evt.target)) {
        this.menu = false
      }
    },
    switchMenu () {
      this.menu = !this.menu
    },
    closeMenu () {
      this.menu = false
    },
    winWidth () {
      var w = document.body.clientWidth
      if (w < 500) {
        this.showBurger = true
      } else {
        this.showBurger = false
      }
    },
    openRegisterPopup () {
      this.isShowLoginPopup = false
      this.isShowRegisterPopup = true
    },
    closeRegisterPopup () {
      this.isShowRegisterPopup = false
    },
    openMailRegisterPopup1 () {
      this.isShowMailRegisterPopup1 = true
      this.isShowRegisterPopup = false
    },
    closeMailRegisterPopup1 () {
      this.isShowMailRegisterPopup1 = false
    },
    openLoginPopup () {
      this.isShowRegisterPopup = false
      this.isShowMailRegisterPopup1 = false
      this.isShowLoginPopup = true
    },
    closeLoginPopup () {
      this.isShowLoginPopup = false
    },
    openMailLoginPopup () {
      this.isShowLoginPopup = false
      this.isShowMailLoginPopup = true
    },
    closeMailLoginPopup () {
      this.isShowMailLoginPopup = false
    },
    openForgetPassword () {
      this.isShowMailLoginPopup = false
      this.isShowForgetPassword = true
    },
    closeForgetPassword () {
      this.isShowForgetPassword = false
    }
    // googleLoginBtn () {
    //   axios.get('https://api.reborn.in/oauth2/authorization/google')
    //     .then((response) => {
    //       console.log(response)
    //     })
    //     .catch(function (error) {
    //       console.log(error)
    //     })
    // },
    // facebookLoginBtn () {
    //   axios.get('https://api.reborn.in/oauth2/authorization/facebook')
    //     .then((response) => {
    //       console.log(response)
    //     })
    //     .catch(function (error) {
    //       console.log(error)
    //     })
    // }
  }
}
</script>
<style lang="scss" scoped>
.app-header {
  position: fixed;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  background-color: white;
  box-shadow: 2px 4px 10px rgba(234, 234, 234, 0.25);
  z-index: 2;

  &-slide {

  }

  .fake-test {
    color: white;
  }

  &-box {
    max-width: 1170px;
    width: 100%;
    height: 72px;
    margin: auto;
    padding: 0px 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    z-index: 3;
  }

  .logo-icon {
    width: 110px;
    height: 30px;

    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
  }

  .header {

    &-link-nav {
      display: flex;
      align-items: center;
    }

    &-link {
      color: #25282B;
      margin-right: 40px;
      cursor: pointer;
      border-bottom: 3px solid transparent;

      &:last-child {
        margin-right: 0px;
      }

      &:hover {
        border-bottom: 3px solid #25282B;
      }
    }

    &-logo-icon {

      &:hover {
        border-bottom: 3px solid transparent;
      }
    }

    &-link-register {

    }

    &-login-box {
      color: #25282B;
      margin-right: 40px;
      display: flex;
      align-items: center;

      &:hover {
        // color: #007BFF;;
        cursor: pointer;
        opacity: 0.8;
      }
    }

    &-login-icon {
      width: 40px;
      height: 40px;
      border-radius: 100%;
      margin-right: 10px;
    }

    &-login {
      margin-right: 20px;
    }
  }

  .burger-icon {
    display: none;
  }

  .header-popup {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;

    .popup {

      &-box {
        width: 430px;
        padding: 22px 22px 50px;
        background: #FFFFFF;
        border: 3px solid #25282B;
        border-radius: 10px;
      }

      &-close {
        display: flex;
        justify-content: flex-end;

        .close {
          width: 24px;
          height: 24px;
          cursor: pointer;

          &:hover {
            opacity: 0.8;
          }
        }
      }

      &-title {
        font-size: 32px;
        font-weight: bold;
        text-align: center;
        margin: 16px 0px 40px;
      }

      &-google {
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 3px solid #25282B;
        border-radius: 32px;
        margin-top: 20px;
        text-align: center;
        color: #25282B;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }

        .google {
          margin-right: 12px;
        }
      }

      &-google-input {
        background: none;
        color: #25282B;
        border: 0px;
        height: 50px;
        cursor: pointer;

        &:focus {
          outline: none;
        }
      }

      &-or {
        margin-top: 16px;
        font-size: 12px;
        color: #A0A4A8;
        text-align: center;
      }

      &-input {
        width: 100%;
        height: 36px;
        color: #646B71;
        margin-top: 28px;
        border: 0px;
        border-bottom: 1px solid #25282B;
      }

      &-btn {
        height: 48px;
        line-height: 48px;
        background: #25282B;
        border-radius: 32px;
        text-align: center;
        color: white;
        margin-top: 32px;
        cursor: pointer;

        &:hover {
          background: #007BFF;
        }
      }

      &-hint {
        margin-top: 24px;
        text-align: center;
      }

      &-login-hint {
        margin-top: 24px;
        text-align: center;
        cursor: pointer;
      }

      &-dash {
        cursor: pointer;
        text-decoration: underline;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
}

@media( max-width: 1023px ){

  .app-header {

    .logo-icon-logo {
      margin: 8px 0px 0px 0px;
    }

    &-box {
      height: 52px;
      padding: 30px 26px;
    }

  .fake-test {
    display: none;
  }

    // menu

    .header {

      &-link-nav {
        display: none;
      }

      &-menu-top {
        display: flex;
        justify-content: space-between;
        margin-bottom: 40px;

        .logo-icon-reborn {
          width: 97px;
          height: 40px;
          margin: 20px 0px 0px 26px;
        }

        .logo-icon-close {
          width: 30px;
          height: 30px;
          margin: 26px 26px 0px 0px;
        }
      }

      &-menu {
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 1000px;
        display: flex;
        flex-direction: column;
        background: #fff;
        z-index: 1;

        &-item {
          font-size: 16px;
          color: #25282B;
          padding: 0px 0px 30px 24px;
        }

        &-line {
          height: 1px;
          background-color: #C8CCD1;
          margin: 0px 20px 30px;
        }
      }

      // menu icon

      .burger-icon {
        display: block;
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
    }

    .burger-icon-burger {
      // margin: 14px 4px 0px 0px;
      display: block;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }

    // popup

    .header-popup {

      .popup {

        &-box {
          max-width: 430px;
          width: 90%;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/layout/AppHeader.vue